<template>
  <div class="main-wrapper" v-if="items">
    <el-row style="margin: 10px 0; font-size: 14px">
      用户总数：
      <el-tag style="margin-right: 15px">{{ count }}</el-tag>
    </el-row>

    <el-form :inline="true" :model="formInline">
      <el-form-item label="Id">
        <el-input v-model="formInline.id" placeholder="Id"></el-input>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="formInline.keyword" placeholder="关键字"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click.prevent="btnSearchClick">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="items" style="width: 100%">
      <el-table-column label="头像" width="100">
        <template #default="scope">
          <el-link :underline="false">
            <el-avatar :size="40" :src="scope.row.avatarUrl || DEFAULT_AVATAR_URL"></el-avatar>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column width="80" prop="id" label="Id"></el-table-column>
      <el-table-column label="账号">
        <template #default="scope">
          <el-link :underline="false" type="primary">{{ scope.row.userName }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="手机" width="120">
        <template #default="scope">
          <div v-if="scope.row.mobile">
            {{ scope.row.mobile }}
            <el-tag v-if="scope.row.mobileVerified">已验证</el-tag>
            <el-tag v-else type="warning">待验证</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180" prop="createdDate" label="注册日期"></el-table-column>
      <el-table-column width="180" prop="countOfLogin" label="登录次数" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template #default="scope">
          <div class="actions">
            <el-link
              type="primary"
              :underline="false"
              href="javascript:;"
              @click.prevent="btnResourcesClick(scope.row)"
            >
              资 源
            </el-link>
            <el-link type="primary" :underline="false" href="javascript:;" @click.prevent="btnEditClick(scope.row)">
              编 辑
            </el-link>
            <el-link type="danger" :underline="false" href="javascript:;" @click.prevent="btnDeleteClick(scope.row)">
              删 除
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: center; margin-top: 10px">
      <el-pagination
        v-on:current-change="handleCurrentChange"
        :current-page="formInline.currentPage"
        :page-size="formInline.limit"
        layout="total, prev, pager, next, jumper"
        :total="count"
      ></el-pagination>
    </div>

    <el-drawer :title="user.id > 0 ? '编辑用户' : '新建用户'" direction="rtl" size="60%" v-model="isFormAdd" @opened="formReset">
      <el-form style="margin: 0 30px" ref="form" :model="user" label-position="top">
        <el-form-item label="用户名" prop="userName" :rules="{ required: true, message: '请输入用户名' }">
          <el-input :disabled="user.id > 0" v-model="user.userName" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile" :rules="{ required: true, message: '请输入手机号码' }">
          <el-input v-model="user.mobile" placeholder="手机号码"></el-input>
        </el-form-item>
      </el-form>

      <el-divider></el-divider>

      <div class="el-dialog__footer">
        <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
        <el-button @click="isFormAdd = false">取 消</el-button>
      </div>
    </el-drawer>

    <el-drawer title="用户资源" direction="rtl" size="80%" v-model="isResources">
      <el-row :gutter="20">
        <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
          用户：{{ user.userName }}，手机：{{ user.mobile }}
        </el-col>
      </el-row>

      <div style="width: 90%; margin: 10px auto">
        <el-table :data="hosts">
          <el-table-column label="网站云实例ID/名称">
            <template #default="scope">
              <el-link
                type="primary"
                style="margin-right: 5px"
                :underline="false"
                :href="getUrl(scope.row.hostName, scope.row.nodeName, scope.row.isHongKong)"
                target="_blank"
              >
                {{ getHostName(scope.row) }}
              </el-link>
              <br v-if="scope.row.nickName" />
              <el-link :underline="false">
                {{ scope.row.nickName }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="网站云版本" width="140">
            <template #default="scope">
              {{ getHostType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="140" align="center">
            <template #default="scope">
              {{ scope.row.createdDate }}
            </template>
          </el-table-column>
          <el-table-column label="到期时间" width="140" align="center">
            <template #default="scope">
              {{ scope.row.expirationDate }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="140" align="center">
            <template #default="scope">
              {{ scope.row.isRunning ? '运行中' : '已停止' }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-divider></el-divider>

      <div style="width: 90%; margin: 10px auto">
        <el-table :data="clouds">
          <el-table-column label="云助手版本">
            <template #default="scope">
              {{ getCloudType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="140" align="center">
            <template #default="scope">
              {{ scope.row.createdDate }}
            </template>
          </el-table-column>
          <el-table-column label="到期时间" width="140" align="center">
            <template #default="scope">
              {{ scope.row.cloudType === 'Free' ? '' : scope.row.expirationDate }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-divider></el-divider>

      <div style="width: 90%; margin: 10px auto">
        <el-table :data="themes" width="100%">
          <el-table-column label="模板名称">
            <template #default="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="下单时间" width="150">
            <template #default="scope">
              {{ scope.row.createdDate }}
            </template>
          </el-table-column>
          <el-table-column label="价格" width="150">
            <template #default="scope">
              {{ scope.row.amount }}
            </template>
          </el-table-column>
        </el-table>

        <div v-if="resourceAddForm.resourceType === 'Theme'">
          <el-form style="margin: 0 30px" ref="resourceAddForm" :model="resourceAddForm" label-position="top">
            <el-form-item label="模板Id" prop="themeId" :rules="{ required: true, message: '请输入模板Id' }">
              <el-input v-model="resourceAddForm.themeId" placeholder="模板Id"></el-input>
            </el-form-item>
            <el-divider></el-divider>
            <div class="el-dialog__footer">
              <el-button type="primary" @click="btnAddResourceSubmitClick">确 定</el-button>
              <el-button @click="resourceAddForm.resourceType = ''">取 消</el-button>
            </div>
          </el-form>
        </div>

        <br />
        <el-form :inline="true">
          <el-form-item>
            <el-button type="primary" @click.prevent="btnAddResourceClick('Theme')">添加模板</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-divider></el-divider>

      <div style="width: 90%; margin: 10px auto">
        <el-table :data="extensions" width="100%">
          <el-table-column label="插件名称">
            <template #default="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="下单时间" width="150">
            <template #default="scope">
              {{ scope.row.createdDate }}
            </template>
          </el-table-column>
          <el-table-column label="价格" width="150">
            <template #default="scope">
              {{ scope.row.amount }}
            </template>
          </el-table-column>
        </el-table>

        <div v-if="resourceAddForm.resourceType === 'Extension'">
          <el-form style="margin: 0 30px" ref="resourceAddForm" :model="resourceAddForm" label-position="top">
            <el-form-item label="插件Id" prop="extensionId" :rules="{ required: true, message: '请输入插件Id' }">
              <el-input v-model="resourceAddForm.extensionId" placeholder="插件Id"></el-input>
            </el-form-item>
            <el-divider></el-divider>
            <div class="el-dialog__footer">
              <el-button type="primary" @click="btnAddResourceSubmitClick">确 定</el-button>
              <el-button @click="resourceAddForm.resourceType = ''">取 消</el-button>
            </div>
          </el-form>
        </div>

        <br />
        <el-form :inline="true">
          <el-form-item>
            <el-button type="primary" @click.prevent="btnAddResourceClick('Extension')">添加插件</el-button>
          </el-form-item>
        </el-form>
      </div>

    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PER_PAGE, DEFAULT_AVATAR_URL } from '@/const';
import { ICloud, IExtension, IHost, ITheme, IUser } from '@/types/models';
import api, { IResourceAddRequest } from '@/api/admin/users';
import utils from '@/utils';
import { IElForm } from '@/types/element';

interface IForm {
  id: string;
  keyword: string;
  currentPage: number;
  offset: number;
  limit: number;
}

interface IState {
  DEFAULT_AVATAR_URL: string;
  items: IUser[];
  count: number;
  formInline: IForm;
  user: IUser;
  isFormAdd: boolean;
  isResources: boolean;
  hosts: IHost[];
  clouds: ICloud[];
  themes: ITheme[];
  extensions: IExtension[];
  resourceAddForm: IResourceAddRequest;
}

export default defineComponent({
  data() {
    return {
      DEFAULT_AVATAR_URL,
      items: [],
      count: 0,
      formInline: {
        id: '',
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: PER_PAGE,
      },
      user: {} as IUser,
      isFormAdd: false,
      isResources: false,
      hosts: [],
      clouds: [],
      themes: [],
      extensions: [],
      resourceAddForm: {} as IResourceAddRequest,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        if (!res) return;

        this.items = res.items;
        this.count = res.count;
      });
    },

    apiDelete(user: IUser) {
      api.delete(user.id, (res) => {
        if (!res) return;

        utils.success(`用户 ${user.userName} 删除成功！`);
        this.apiGet();
      });
    },

    apiResources(userId: number) {
      api.resources(userId, (res) => {
        if (!res) return;

        this.isResources = true;
        this.hosts = res.hosts;
        this.clouds = res.cloud != null ? [res.cloud] : [];
        this.themes = res.themes;
        this.extensions = res.extensions;
      });
    },

    apiResourceAdd() {
      this.resourceAddForm.userId = this.user.id;
      api.resourceAdd(this.resourceAddForm, (res) => {
        if (!res) return;

        utils.success('资源添加成功！');
        this.resourceAddForm = {} as IResourceAddRequest;
        this.apiResources(this.user.id);
      });
    },

    getHostName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    getHostType(host: IHost) {
      return utils.getHostType(host.hostType);
    },

    getCloudType(cloud: ICloud) {
      return utils.getCloudType(cloud.cloudType);
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    formReset() {
      const form = this.$refs.form as IElForm;
      form.clearValidate();
    },

    btnSearchClick() {
      this.apiGet();
    },

    btnEditClick(user: IUser) {
      this.user = { ...user };
      this.isFormAdd = true;
    },

    btnResourcesClick(user: IUser) {
      this.user = { ...user };
      this.apiResources(this.user.id);
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          api.submit(this.user, (res) => {
            if (!res) return;
            this.isFormAdd = false;
            this.apiGet();
            utils.success(`用户${this.user.id > 0 ? '修改' : '添加'}成功`);
          });
        }
      });
    },

    btnDeleteClick(user: IUser) {
      utils.alertDelete(
        {
          title: '删除用户',
          text: `此操作将删除用户 ${user.userName}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(user);
        },
      );
    },

    btnAddResourceClick(resource: string) {
      this.resourceAddForm.resourceType = resource;
    },

    btnAddResourceSubmitClick() {
      (this.$refs.resourceAddForm as IElForm).validate((valid) => {
        if (valid) {
          this.apiResourceAdd();
        }
      });
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      this.btnSearchClick();
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
